// extracted by mini-css-extract-plugin
export default {"annotationsContainer":"style_annotationsContainer__ebcfL","actionButton":"style_actionButton__41Dig","openIcon":"style_openIcon__f867n"};